/**
 * @name ucFirst
 * @description Capitalise the first letter of a string
 */
export const ucFirst = (string: string): string =>
  string.charAt(0).toUpperCase() + string.slice(1);
